import axios from "axios";
import Paths from "../../constant/constant";

export async function addUser(body) {
  return await axios
    .post(Paths.API_URL + `/api/v1/adduser/${body.email}`, body)
    .then((res) => {})
    .catch(function (e) {});
}
